export default function Cta({ className, children, skewBottom = true }) {
    return (
        <section className="section-cta">
            <div className={className}>
                <div className="skew-top"></div>
                <div className={`container`}>
                    <div className="flex flex-col items-center py-20">{children}</div>
                </div>
                {skewBottom && <div className="skew-bottom"></div>}
            </div>
        </section>
    );
}
